import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';

const Guestbook = () => {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    const fetchEntries = async () => {
      const q = query(collection(db, "guestbook"), orderBy("timestamp", "desc"));
      const snapshot = await getDocs(q);
      // Include document ID, and only show entries with a valid timestamp and message
      const data = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(entry => entry.timestamp && entry.message); // Only entries with timestamp & message
      setEntries(data);
    };
    fetchEntries();
  }, []);

  return (
    <div className="guestbook-messages">
      {entries.length === 0 && (
        <p className="text-center text-gray-600">No messages yet. Be the first to sign the guestbook!</p>
      )}
      {entries.map((entry) => (
        <div key={entry.id} className="guestbook-message-card">
          <span className="guestbook-name">{entry.isAnonymous ? "Anonymous" : entry.name}</span>
          <span className="guestbook-message">{entry.message}</span>
        </div>
      ))}
    </div>
  );
};

export default Guestbook;
